import { defineStore } from 'pinia';

import type { BankTransactionBase } from '@stuut/api/models';

interface State {
  transactions: BankTransactionBase[];
}

export const useBankTransactions = defineStore('bankTransactions', {
  getters: {
    getById: (state) => {
      return (transactionId: string) =>
        state.transactions.find((transaction) => transaction.id === transactionId) as
          | BankTransactionBase
          | undefined;
    },
  },

  state: (): State => ({
    transactions: [],
  }),
});

export default useBankTransactions;
